import { CloudServiceProvider } from '../../constants/AppConstants';
import { EnvironmentTypesEnum } from '../../pages/Dashboard/DashboardCover/MigrateModernize/Environments/EnvironmentPatternConstants';
import { IMultipartFormData } from '../services/MultipartFormData.data';

export interface ILandingZoneResponse {
  LandingZoneName: string;
  CurrentStatus: LandingZoneStatus;
  LandingZoneId: string;
  Errors: string;
  Sector: ILandingZoneSector;
  GCPProjectId: string;
  MicroserviceInfo: {
    status: LzMicroserviceStatus;
    ids: string;
  };
  CloudServiceProvider: CloudServiceProvider;
  CreatedOn: string;
  IAC?: string;
  industryComplianceId?: string;
  industryComplianceName?: string;
  complianceStandardList: Array<string>;
  AccountId: string;
  ProjectId: string;
}
export enum ILandingZoneSector {
  GENERAL = 'GENERAL',
  CONSUMER = 'CONSUMER',
  FINANCIAL = 'FINANCIAL SERVICES',
  ENERGY = 'ENERGY, RESOURCES & INDUSTRIALS',
  GOVERNMENT = 'GOVERNMENT & PUBLIC SERVICES',
  HEALTH = 'HEALTHCARE',
  TECHNOLOGY = 'TECHNOLOGY, MEDIA & TELECOMMUNICATION',
}

export enum LandingZoneStatus {
  CREATED = 'Created',
  IN_PROGRESS = 'In Progress',
  ERROR = 'Error',
  DELETE_IN_PROFRESS = 'delete in progress',
  RUNNING = 'Running',
  ACTIVE = 'Active',
  DELETED = 'Deleted',
  COMPLETED = 'Completed',
}

export enum LzMicroserviceStatus {
  NOT_ENABLED = 'notEnabled',
  CREATED = 'Created',
  IN_PROGRESS = 'inProgress',
  ERROR = 'Error',
}

export interface IGetPresignedURLToUploadResponse {
  message: string;
  url: string;
}

export interface IGetPresignedURLResponse {
  message: string;
  url: string;
}

export interface IBuildDeployErrorState {
  errorKey: string;
  errorValue: string[];
}

export enum IDeployStatus {
  DEPLOYED = 'Deployed',
  YET_TO_START = 'Yet To Start',
  CREATED = 'Created',
  COMPLETED = 'Completed',
  DELETE_IN_PROFRESS = 'Deletion in progress',
}
export interface IGetWorkloadQueryParams {
  project: string;
  account: string;
}
export type IGetEnvironmentsQueryParams = IGetWorkloadQueryParams;

export interface IWorkloadPatternRespObj {
  CurrentStatus: string;
  Sector: ILandingZoneSector;
  CreatedOn: string;
  WorkloadPatternId: string;
  TangraAccountId: string;
  AppId: string;
  Source: string;
  EndTime: string;
  IAC: string;
  Errors: string;
  WorkloadType: string;
  Email: string;
  UserId: string;
  EnvironmentId: string;
  AppProvision: string;
  CloudServiceProvider: string;
  MicroserviceInfo: {
    status: string;
  };
  CluserName: string[];
  ClusterTFstatePath: string;
  TangraProjectId: string;
  CluserRegion: string;
  AppType: string;
  PolicyList: [];
  EnvironmentName: string;
}

export interface IAllEnvironmentsRespObj {
  CurrentStatus: LandingZoneStatus;
  Sector: ILandingZoneSector;
  CreatedOn: string;
  WorkloadPatternId: string;
  TangraAccountId: string;
  Source: string;
  IAC: string;
  Errors: string;
  ResourceList: string[];
  Email: string;
  UserId: string;
  WorkloadProvision: string;
  EnvironmentId: string;
  EnvironmentName: string;
  LandingZoneName: string;
  MicroserviceInfo: {
    status: string;
  };
  TFstatePath: string;
  TangraProjectId: string;
  EnvironmentType: EnvironmentTypesEnum;
  LandingZoneId: string;
  PolicyList: [];
  CloudServiceProvider: CloudServiceProvider;
  environmentName: string;
}

export interface ICreateEnvironmentPayload {
  userdata: {
    userId: string;
    email: string;
    project: string;
    account: string;
    isPresent: boolean;
    environmentVersion: string;
    sector: ILandingZoneSector;
    landingZoneName: string;
    landingZoneId: string;
    csp: CloudServiceProvider;
    iac: string;
    environmentName: string;
    environmentType: EnvironmentTypesEnum;
    complianceStandardList: Array<string>;
    gcp?: {
      projectName: string;
      region: string;
    };
    industryComplianceName?: string;
    planId: string;
  };
  file: IMultipartFormData;
}

export interface IDownloadArchitectureDiagramPayload {
  fileId: string;
  fileType: string;
}

export interface IUploadArchitecturePayload {
  userId: string;
  techPlatform: string;
  architectureName: string;
  category: string;
  techDomain: string;
  description: string;
  releventUsecase: string;
  visioFile: any;
  yamlFile: any;
}

export interface IFetchCategoryAndTechDomainResponse {
  category: Array<ICategoryDropdownOptions>;
  domains: Array<ICategoryDropdownOptions>;
}

export interface ICategoryDropdownOptions {
  name: string;
  type: string;
  label: string;
}
